let Page      = require('../mixins/base-page');
let htmlClass = require('../mixins/html-class-toggle');

module.exports = {
	mixins: [Page, htmlClass],

	props: {
		baseUnit: {
			required: true,
			type: String
		},
		completeEndpoint: {
			type: String
		},
		unitOptions: {
			required: true,
			type: Array
		},
		multiplierOptions: {
			type: Array,
			default: function() {
				return [1,2,3,4,5,6,7,8,9,10,15,20,25,30,35,40,45,50];
			}
		},
		segments: {
			require: true,
			type: Array
		}
	},

    data() {
        return {
        	endpoint: this.completeEndpoint,
			unitSelected: this.baseUnit,
			lessonAssessmentResponses: [],
			lessonCompleted: false,
			lessonCompleting: false,
			showCompleteConfirm: false,
			skipAssessment: false,
			videoTimestamp: 0,
			unitMultiplier: 1,
        }
    },

    computed: {
    	lessonScore() {
    		return this.lessonAssessmentResponses.length;
    	}
    },

    methods: { 
		filterUnits(data) {
			this.unitSelected = data.value;
		},

		lessonScorePercentage(assessments) {
			return Math.round((this.lessonScore / assessments) * 100);
		},
		
		playVideoAt(seconds) {
			this.videoTimestamp = seconds;
		},
		
		showLessonConfirm(assessment = true) {
			this.skipAssessment = !assessment;
			this.showCompleteConfirm = true;
  		},
  		
  		completeLesson() {
				console.log('completeLesson')
			this.lessonCompleting = true;
  			this.sendRequest(this.endpoint, 'post', this.completedLesson);
		},

		completedLesson: function(data, message) {
			let vueScrollTo = require('vue-scrollTo');

			this.lessonCompleting = false;

			vueScrollTo.scrollTo('#spark-app', 0.1, {
			    easing: vueScrollTo.easing['ease-in'],
	    		offset: 0
			});

			this.toggleHtmlClass('lesson-completed');
			this.lessonCompleted = true;
		}
  	}
};
